import { cloneDeep } from "lodash";
import { allClassificationTypesOptions, allDataSourcesOptions, allMeasureUnitsOptions, allMutuallyRedeemingLevelOptions, allMutuallyRedeemingOptions, allPeriodicitiesOptions, allReportNamesOptions, allReportTypesOptions } from "../../common/baseOptions";
import { Classificator } from "../../common/types/Classificator";
import { Template } from "../../common/types/Template";
import { Report243FilterSettings } from "./settings/Report243FilterSettings";
import { Report243FilterOptions } from "./options/Report243FilterOptions";
import { Indicator } from "../../common/types/Indicator";
import { Option } from "../../common/types/Option";
import {ByForm, IncomeLevel, Segmentation} from "../../common/types/roots/fields";
import {Draggable} from "@/modules/budget/monitoring/reports-constructor/common/types/Draggable";

export const report243IncomeClassificators: Classificator[] = [
    { key: 'kat', active: true, selected: [] },
    { key: 'cls', active: true, selected: [] },
    { key: 'pcl', active: true, selected: [] },
    { key: 'spf', active: true, selected: [] }
]
export const report243Indicators: Indicator[] = [
    { key: 'total', active: true },
    { key: 'total_prev', active: true },
    { key: 'deviation_total', active: true },
    { key: 'january', active: true },
    { key: 'january_prev', active: true },
    { key: 'deviation_january', active: true },
    { key: 'february', active: true },
    { key: 'february_prev', active: true },
    { key: 'deviation_february', active: true },
    { key: 'march', active: true },
    { key: 'march_prev', active: true },
    { key: 'deviation_march', active: true },
    { key: 'april', active: true },
    { key: 'april_prev', active: true },
    { key: 'deviation_april', active: true },
    { key: 'may', active: true },
    { key: 'may_prev', active: true },
    { key: 'deviation_may', active: true },
    { key: 'june', active: true },
    { key: 'june_prev', active: true },
    { key: 'deviation_june', active: true },
    { key: 'july', active: true },
    { key: 'july_prev', active: true },
    { key: 'deviation_july', active: true },
    { key: 'august', active: true },
    { key: 'august_prev', active: true },
    { key: 'deviation_august', active: true },
    { key: 'september', active: true },
    { key: 'september_prev', active: true },
    { key: 'deviation_september', active: true },
    { key: 'october', active: true },
    { key: 'october_prev', active: true },
    { key: 'deviation_october', active: true },
    { key: 'november', active: true },
    { key: 'november_prev', active: true },
    { key: 'deviation_november', active: true },
    { key: 'december', active: true },
    { key: 'december_prev', active: true },
    { key: 'deviation_december', active: true }
]

// Уровень дохода — значения как у «Тип бюджета» в Казначейских формах (форма 2-43)
export const F243IncomeLevelOptions: Option<IncomeLevel>[] = [
    { value: '00', label: 'Все', labelKk: 'Барлығы', labelEn: 'All' },
    { value: '01', label: 'Республиканский', labelKk: 'Республикалық', labelEn: 'Republic' },
    { value: '02', label: 'Областной', labelKk: 'Облыстық', labelEn: 'Regional' },
    { value: '03', label: 'Районный', labelKk: 'Аудандық', labelEn: 'District' },
    { value: '04', label: 'МСУ', labelKk: 'Жергілікті', labelEn: 'Local' },
    { value: '06', label: 'Город респ. значения', labelKk: 'Респ. маңызы бар қала', labelEn: 'City with republican status' }
]

export const F243ByFormOptions: Option<ByForm>[] = [
    { value: '2-43', label: '2-43', labelKk: '2-43', labelEn: '2-43' }
]

// Нужна как временная затычка (При созданий нового берутся пустые настройки)
const tempSettings: Report243FilterSettings = {
    // Base:
    reportName: '2-43',
    reportType: 'REGULATED',
    classificationType: 'INCOMES',
    dataSource: 'IISK',
    periodicity: 'PERIOD',
    // Custom:

    regions: [],
    byForm: '2-43',
    incomes: [],
    segmentations: [],
    period: { from: '', to: '' },
    periodPrev: { from: '', to: '' },
    comparePrevYear: true,
    senderbin: [],
    oked: [],
    kfs: [],
    kse: [],
    krp: [],

    indicators: cloneDeep(report243Indicators),

    measureUnit: 'THOUSAND',
    isTree: true,
    byBudgetLevel: false,
    roundUpTo: null,
    topNCount: null,
    fillCbc: false,
    mutuallyRedeeming: 'WITHOUT',
    mutuallyRedeemingLevels: [],
    incomeLevel: '00',
}

export const report243BaseTemplate: Template = {
    id: null,
    name: 'Анализ поступлений бюджета по 2-43',
    excelName: null,
    description: null,
    category: '100',
    regions: [],
    userId: '',
    filterSettings: tempSettings
}

const F243SegmentationOptions: Draggable<Segmentation>[] = [
    { value: 'OKED', label: "ОКЭД", labelKk: "ЭҚЖЖ", labelEn: "Economic Activity (OKED)", active: true },
    { value: 'REGION', label: "Регион", labelKk: "Аймақ", labelEn: "Region", active: true },
    { value: 'SENDERBIN', label: "Плательщик", labelKk: "Төлеуші", labelEn: "Taxpayer", active: true },
    { value: 'KBK', label: "КБК", labelKk: "БСК", labelEn: "KBK", active: true }
]

export const report243FilterOptions: Report243FilterOptions = {
    // Base:
    key: '2-43',
    reportNames: cloneDeep(allReportNamesOptions),
    reportTypes: cloneDeep(allReportTypesOptions),
    classificationTypes: cloneDeep(allClassificationTypesOptions.filter(it => it.value === 'INCOMES')),
    dataSources: cloneDeep(allDataSourcesOptions.filter(it => it.value !== 'MIXED')),
    periodicities: cloneDeep(allPeriodicitiesOptions),
    // Custom:
    measureUnits: cloneDeep(allMeasureUnitsOptions),
    regions: [], // Загружается с бэка
    byForms: cloneDeep(F243ByFormOptions),
    incomes: cloneDeep(report243IncomeClassificators),
    indicators: cloneDeep(report243Indicators),
    segmentations: F243SegmentationOptions,
    senderbin: [], // Загружается с бэка
    oked: [], // Загружается с бэка
    kfs: [], // Загружается с бэка
    kse: [], // Загружается с бэка
    krp: [], // Загружается с бэка
    mutuallyRedeeming: cloneDeep(allMutuallyRedeemingOptions),
    mutuallyRedeemingLevels: cloneDeep(allMutuallyRedeemingLevelOptions),
    incomeLevels: cloneDeep(F243IncomeLevelOptions)
}